import { render } from "./ViewerOverlayCallView.vue?vue&type=template&id=8be54cbe&scoped=true"
import script from "./ViewerOverlayCallView.vue?vue&type=script&lang=js"
export * from "./ViewerOverlayCallView.vue?vue&type=script&lang=js"

import "./ViewerOverlayCallView.vue?vue&type=style&index=0&id=8be54cbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be54cbe"]])

export default __exports__